export function svgElementFromString(str: string, forImg = false) {
    const base64 = btoa(unescape(encodeURIComponent(str)));
    const data = `data:image/svg+xml;base64,${base64}`;
    return forImg ? data : `url(${data})`;
}

export function strToSvg(str: string) {
    const div = document.createElement('DIV');
    div.innerHTML = str;
    const svg = div.querySelector('svg');

    if (!svg) {
        throw Error('<svg> tag not found');
    }

    return svg;
}
